import { ThemeProvider } from 'styled-components';
import '../Themes/DefaultOffset.css';
import { darkTheme } from '../Themes/Themes';
import { useDimensions } from '../hooks';
import { MobileNavigation } from './MobileNavigation';
import { DesktopNavigation } from './DesktopNavigation';
import { useBreakpointTransition } from './hooks';
import { jsx as _jsx } from "react/jsx-runtime";
function Navigation({
  links,
  MobileFooterComponent,
  theme,
  ...rest
}) {
  const {
    isMobile
  } = useDimensions();
  useBreakpointTransition();
  const currentTheme = theme || darkTheme;
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: currentTheme,
    children: isMobile ? /*#__PURE__*/_jsx(MobileNavigation, {
      links: links,
      MobileFooterComponent: MobileFooterComponent,
      ...rest
    }) : /*#__PURE__*/_jsx(DesktopNavigation, {
      links: links,
      ...rest
    })
  });
}
export default Navigation;